import Text from '@/components/Text';
import { cn } from '@/lib/cn';
import PluginIcon from 'pages/scope/PluginIcon';
import { useAvailableDataStreamDefinitionsForWorkspace } from 'queries/hooks/useAvailableDataStreamDefinitionsForWorkspace';
import { useSplashScreenDataStreamSelect } from '../hooks/useSplashScreenDataStreamSelect';
import { TileEditorDataStreams } from '../state/useTileEditorDataStreams';

interface SplashScreenDatasourceButtonProps {
    id: string;
    name: string;
    dataStreams: NonNullable<ReturnType<typeof useAvailableDataStreamDefinitionsForWorkspace>['data']>;
    tileEditorDataStreams: TileEditorDataStreams;
}

export const SplashScreenDatasourceButton: React.FC<SplashScreenDatasourceButtonProps> = ({ 
    id,
    name, 
    dataStreams, 
    tileEditorDataStreams 
}) => {
    const { selectDatasource } = useSplashScreenDataStreamSelect(id, dataStreams, tileEditorDataStreams);

    return (
        <button 
            key={id}
            className={cn(
                'flex items-center text-textSecondary px-5 py-2 @4xl/datasources:py-4 gap-2 shrink-0 rounded-md w-[100px] @4xl/datasources:w-[120px] flex-col bg-tileEditorDataset hover:bg-tileEditorDatasetActive focus:bg-tileEditorDatasetActive hover:text-textPrimary focus:text-textPrimary'
            )}
            onClick={() => selectDatasource()}
        >
            <div className='w-full max-w-14 aspect-square @4xl/datasources:max-w-16'>
                <PluginIcon     
                    pluginName={name} 
                    className='w-full'
                />
            </div>
            
            <Text.H4 className='text-sm @4xl/datasources:text-[14px] text-center min-h-[35px] flex items-center'>{name}</Text.H4>
        </button>
    );
};
